const applyMask = ({ prevMaskedValue, insertedValue, applyFromIndex = 0 }) => {
  let pointer = applyFromIndex, newValue = prevMaskedValue.slice(0, applyFromIndex), cursorPosition = prevMaskedValue.length;
  for (; pointer < prevMaskedValue.length && insertedValue; ) {
    const symbol = prevMaskedValue[pointer];
    if (pointer++, /[^ymd0-9]/i.test(symbol)) {
      newValue = newValue + symbol;
      continue;
    }
    newValue = newValue + insertedValue[0], insertedValue = insertedValue.slice(1);
  }
  return newValue.length < prevMaskedValue.length && (cursorPosition = newValue.length, newValue = newValue + prevMaskedValue.slice(newValue.length)), { maskedValue: newValue, cursorPosition };
};
export {
  applyMask
};
//# sourceMappingURL=applyMask.js.map
